import React, { useEffect, useState } from 'react'
import poServices from '../poServices';

function POTransactions({poId}) {

    const [poTransactionList,setPoTransectionList] = useState(null);
    const [total,setTotal] =    useState(0);

    const getPoTransactionList = () =>{
        poServices.getPoTransactionList(poId).then(res=>{
            setPoTransectionList(res.data);
        }).catch(error=>{
            console.log(error);
        })
    }

    const calclulateTotal = () =>{
        if(poTransactionList){
            let _total = poTransactionList.reduce((accumulator, currentItem) => {
                return accumulator + currentItem.amount;
            }, 0);
            setTotal(_total)
        }
    }

    useEffect(()=>{
        calclulateTotal();
    },[poTransactionList])

    useEffect(()=>{
        getPoTransactionList();
    },[])

    return (
        poTransactionList && poTransactionList.length > 0 &&
        
        <table className='table table-bordered'>
            <thead>
                <tr>
                    <td colSpan={4} className='text-center'>Po Payment Transaction</td>
                </tr>
                <tr>
                    <th>Id</th>
                    <th>Transaction No</th>
                    <th>Transaction Date</th>
                    <th>Amount</th>
                </tr>
            </thead>
            <tbody>
                {poTransactionList.map((poTransaction)=>
                    <tr key={poTransaction.id}>
                        <td>{poTransaction.id}</td>
                        <td>{poTransaction.transactionNo}</td>
                        <td>{poTransaction.transactionDate}</td>
                        <td>{Intl.NumberFormat('en-IN').format(poTransaction.amount)  }</td>
                    </tr>
                )}
            </tbody>
            <tfoot>
                <tr>
                    <th colSpan={3}>Total</th>
                    <th>{Intl.NumberFormat('en-IN').format(total)}</th>
                </tr>
            </tfoot>
            
        </table>
    )
}

export default POTransactions